import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { UserService } from '@tekman/onmat/service/generic';
import { GroupService, GroupsFacade } from '@tekman/onmat/store/group';
import { StorageService } from '@tekman/shared/service';
import { filter, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class hasGroupsGuard implements CanActivate {
  constructor(
    private groupService: GroupService,
    private groupsFacade: GroupsFacade,
    private readonly storageService: StorageService,
    private readonly userService: UserService
  ) {}

  hasGroups: boolean;

  canActivate(): Observable<boolean> {
    if (this.userService.isTeacher()) {
      if (this.hasGroups) {
        return of(true);
      }
      return this.groupService.getGroupsByAcademicYear(this.storageService.selectedAcademicYear).pipe(
        map(groups => {
          if (groups?.length && this.storageService.selectedGroupId) {
            this.hasGroups = true;
            return true;
          }
        })
      );
    } else {
      return this.groupsFacade.selectedGroup$.pipe(
        filter(group => !!group),
        map(() => {
          return true;
        })
      );
    }
  }
}
